import cx from 'classnames'
import { useFormContext } from 'react-hook-form'
import { z } from 'zod'

import '@/components/Form/Atoms/PurchaseTypeRadioInput/PurchaseTypeRadioInput.scss'
import { PurchaseType } from '@/types/enum/purchaseType'
import { ProductType } from '@/types/product'
import FormResolverUtils from '@/utils/FormResolverUtils'
import { InputKey } from '@/utils/inputKey'

const formResolverUtils = FormResolverUtils({ schema: z.string(), i18nName: '購入方法' })

export const purchaseTypeRadioDefaultValue: PurchaseType = 'once'

const values: Record<PurchaseType, string> = { once: '都度購入', subscription: '定期購入' }

export const purchaseTypeRadioInputKey = InputKey('PurchaseType', formResolverUtils.enum(values).schema)

export default function PurchaseTypeRadioInput({ product }: { product: ProductType }) {
  const { register } = useFormContext()

  return (
    <>
      <ul
        className="c-purchaseTypeRadioInput-how"
        style={{
          // 初期リリース時にセットや定期がないため、ラジオの選択肢が不要
          display: 'none',
        }}
      >
        <li className="c-purchaseTypeRadioInput-how-box">
          <input
            type="radio"
            id={'once'}
            value={'once'}
            {...register(purchaseTypeRadioInputKey.name)}
            className="c-purchaseTypeRadioInput-how-input"
          />
          <label className="u-mo-lineView c-purchaseTypeRadioInput-how-label" htmlFor="once">
            <span className={cx('c-purchaseTypeRadioInput-how-title', 'u-mo-lineView__text')}>通常購入</span>

            <span className="c-purchaseTypeRadioInput-how-info">
              {product.invoiceItem.overallDiscountRate > 0 && (
                <>
                  <span className="c-purchaseTypeRadioInput-how-privilege">
                    {product.invoiceItem.overallDiscountRate}% OFF
                  </span>
                  <br className="u-sp" />
                </>
              )}
              <span className="c-purchaseTypeRadioInput-how-price">
                ¥{product.invoiceItem.listPriceWithTax.toLocaleString()}
                <span className="c-purchaseTypeRadioInput-how-tax">[税込]</span>
                <span className="c-purchaseTypeRadioInput-how-option"> / {product.capacity}</span>
              </span>
            </span>
          </label>
        </li>
      </ul>

      {/*{product.ableToSubscription && (*/}
      {/*  <label>*/}
      {/*    <input type="radio" value={'subscription'} {...register(purchaseTypeRadioInputKey.name)} />*/}
      {/*    定期購入 {product.invoiceItem.overallDiscountRate}%OFF&送料無料*/}
      {/*  </label>*/}
      {/*)}*/}
    </>
  )
}
